import React, { FC, memo } from 'react';
import { Logo } from '~/shared/components';
import styles from './header-logo.module.css';
import clsx from 'clsx';

type Props = {
    selectedSubMenu?: boolean;
    mobileInverted?: boolean;
    className?: string;
    isSearchPage?: boolean;
};

const HeaderLogo: FC<Props> = memo(
    ({ selectedSubMenu, mobileInverted, className, isSearchPage }) => {
        return (
            <div
                className={clsx(styles.root, className, {
                    [styles.selectedSubMenu]: selectedSubMenu,
                    [styles.searchPage]: isSearchPage,
                })}
            >
                <Logo mobileInverted={mobileInverted} />
            </div>
        );
    }
);

HeaderLogo.displayName = 'HeaderLogo';
export default HeaderLogo;
